import React, { useState } from "react";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ChatPopup from "./ChatPopup";
import { Badge } from "@mui/material";

function Chat() {
  const [totalUnreadMessages, setTotalUnreadMessages] = useState("");

  const [openMessage, setOpenMessage] = useState(false);
  return (
    <div>
      <Badge color="secondary" badgeContent={totalUnreadMessages}>
        <ChatBubbleOutlineIcon
          className="text cursor-pointer"
          sx={{ fontSize: 40 }}
          onClick={() => setOpenMessage(!openMessage)}
        />
      </Badge>
      <ChatPopup
        openMessage={openMessage}
        setOpenMessage={setOpenMessage}
        setTotalUnreadMessages={setTotalUnreadMessages}
      />
    </div>
  );
}

export default Chat;
